
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "income-item" })
export default class IncomeItem extends Vue {
  @Prop() public userName!: string;
  @Prop() public productName!: string;
  @Prop() public amount!: number;
  @Prop() public createTime!: string;
  @Prop() public type!: number;

  public getMessage() {
    !this.userName && (this.userName = "未知用户");
    !this.productName && (this.productName = "未知产品");
    return (
      `<b style="color: rgb(79,165,248)">${this.userName}</b>` +
      " 使用了 " +
      `<b style="color: rgb(244,165,63)">${this.productName}</b>`
    );
  }

  public getMessageByReIncome() {
    return (
      "获得了 " +
      `<b style="color: rgb(244,165,63)">¥${this.amount / 100}</b>` +
      " 佣金"
    );
  }
  public dateToTimestamp(dateStr: string) {
    if (!dateStr) {
      return "";
    }
    let newDataStr = dateStr.replace(/\.|\-/g, "/");
    let date = new Date(newDataStr);
    let timestamp = date.getTime();
    return timestamp;
  }
}
